








import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import BaseVue from "../../../core/BaseVue";
import ReportEvaluation from "@/components/report-components/report-evaluation.vue";
@Component({
  components: {
    ReportEvaluation
  }
})
export default class LastReportEvaluation extends BaseVue {}
